import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import AboutV4 from './section-components/about-v4';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';
import { useLang } from '../i18n/LanguageContext';

const About_v1 = () => {
    const { t } = useLang();
    return <div>
        <Navbar />
        <PageHeader headertitle={t('pageTitles.about')} />
        <AboutV4 />
        <CallToActionV1 />
        <Footer />
    </div>
}

export default About_v1

